import { FC } from "react"
import { FlyoutFooter } from "@app/shared/Flyouts";
import { EcdSpecialtyByGapsAccordion } from "../components/EcdSpecialtyByGapsAccordion";
import { AccordionContainer } from "@app/shared/AccordionContainer";

interface EcdTopSpecialtiesFlyoutSpecialty {
  groupCode: string;
  id: number;
  name: string;
}

interface TopSpecialtiesFlyoutProps {
  specialties: EcdTopSpecialtiesFlyoutSpecialty[];
}


const EcdTopSpecialtiesFlyout: FC<TopSpecialtiesFlyoutProps> = (props: TopSpecialtiesFlyoutProps) => {
  return (
    <>
      <AccordionContainer>
        {props.specialties.map((sp) => {
          return (
            <EcdSpecialtyByGapsAccordion specialtyId={sp.id} specialtyName={sp.name} groupCode={sp.groupCode} key={sp.id} />
          )
        })}
      </AccordionContainer>
      <FlyoutFooter
        submitButton={null}
      />
    </>
  );
}

export default EcdTopSpecialtiesFlyout;
